import React from 'react';

const ActivationCodeExpired = () => {
  return (
    <div className="govuk-width-container mt-10">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-three-quarters">
          <h1 className="govuk-heading-xl">Your activation code has expired</h1>
          <p className="govuk-body">
            The link in the email has expired, for security reasons the links
            are only valid for 1 hour.
          </p>
          <p className="govuk-body">
            Use this link to request a new activation email:{' '}
            <a
              target="_self"
              className="govuk-link govuk-link--no-visited-state"
              href="/resend-activation-email/"
            >
              resend your activation email
            </a>
          </p>
          <p className="govuk-body">
            The email should arrive in a few minutes. If you&apos;ve not
            received the email please check your junk or spam folder.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivationCodeExpired;
